import { Component, inject, OnInit } from '@angular/core';
import { LdwRouterService } from '../../route/ldw-router.service';
import { LDWDocument } from '../../shared/models/LDWDocument';
import { DocumentHelper } from '../../shared/helpers/document-helper';
import { MatDialog } from '@angular/material/dialog';
import { DocumentService } from '../../shared/services/document.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { DocumentHistory } from '../../shared/models/document-history';
import { InfoService } from '../../shared/services/info.service';
import { DocumentDetailResolved } from '../../shared/models/document-detail-resolved';
import { DocumentHistoryResolved } from '../../shared/models/document-history-resolved';
import { SettingsService } from '../../shared/settings/settings.service';


@Component({
    selector: 'ldw-document-history-page',
    templateUrl: './document-history-page.component.html',
    styleUrls: ['./document-history-page.component.css'],
    standalone: false
})
export class DocumentHistoryPageComponent implements OnInit {
  private routerService = inject(LdwRouterService);
  private infoService = inject(InfoService);
  private route = inject(ActivatedRoute);
  private settingsService = inject(SettingsService);

  document: LDWDocument | undefined = undefined;
  history: DocumentHistory[] | [] = [];
  documentHelper: DocumentHelper;
  displayedColumns: string[] = ['archived', 'changed', 'changedBy', 'job'];

  private dialog = inject(MatDialog);
  private translate =  inject(TranslateService);

  constructor() {
    const routerService = this.routerService;

    this.documentHelper = new DocumentHelper(this.dialog, routerService, this.translate);
  }

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      this.infoService.clearStatus();
      const documentResolved: DocumentDetailResolved = data['document'];
      const documentHistoryResolved: DocumentHistoryResolved = data['history'];

      if (documentResolved.documentDetail && documentHistoryResolved.documentHistory) {
        this.document = documentResolved.documentDetail;
        this.history = documentHistoryResolved.documentHistory;
        this.infoService.setLoadedItems(this.history.length);
      } else {
        this.error(documentResolved.docId);
      }

      if (documentResolved.error) {
        this.infoService.setStatus(documentResolved.error);
      } else if (documentHistoryResolved.error) {
        this.infoService.setStatus(documentHistoryResolved.error);
      }
    });
  }

  error(docid: string) {
    this.documentHelper.documentNotFound(docid);
  }

  get viewVisible(): boolean {
    return this.document != undefined && this.document.id != '';
  }

  close() {
    this.routerService.navigateBack();
  }

  showToolTip(): boolean {
    return this.settingsService.settings.viewMode.showTooltips;
  }

  getRoute(row: DocumentHistory) {
    if (this.document == undefined || row == undefined || row.archived == undefined) {
      return;
    }
    return this.routerService.getDocHistoryViewRoute(this.document.id, row.archived);
  }
}
